import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebase";

/**
 * Fetches inventory details for a specific user.
 * @param {string} uid - The user ID to fetch inventory for.
 * @returns {Promise<{ totalInventory: number, distinctBrands: string[] }>} Inventory summary.
 */
export const getUserInventorySummary = async (uid) => {
  if (!uid) throw new Error("User UID is required");

  try {
    const inventoryCollection = collection(db, "all-products");
    const inventorySnapshot = await getDocs(inventoryCollection);

    const userInventory = inventorySnapshot.docs
      .map((doc) => doc.data())
      .filter((item) => item.retailerOrDistributorId === uid);

    // Total Inventory Count
    const totalInventory = userInventory.length;

    // Distinct Brands Calculation
    const brands = new Set(userInventory.map((item) => item.brand?.toLowerCase()));
    const distinctBrands = Array.from(brands);

    return {
      totalInventory,
      distinctBrands,
    };
  } catch (error) {
    console.error("Error fetching user inventory:", error);
    throw new Error(error.message);
  }
};
